import baseUrl from './baseUrl'

export default {
  action: {
    read: 'read',
    permissionLogin: 'login',
    permissionRoleView: 'view-roles',
    permissionRoleAdd: 'add-roles',
    permissionRoleEdit: 'edit-roles',
    permissionRoleDelete: 'delete-roles',
    permissionTranslationView: 'view-translation',
    permissionTranslationAdd: 'add-translation',
    permissionTranslationEdit: 'edit-translation',
    permissionTranslationDelete: 'delete-translation',
    permissionUserView: 'view-users',
    permissionUserAdd: 'add-users',
    permissionUserEdit: 'edit-users',
    permissionUserDelete: 'delete-users',
    permissionApiTokenAdd: 'add-api-tokens',
    permissionApiTokenEdit: 'edit-api-tokens',
    permissionApiTokenDelete: 'delete-api-tokens',
    permissionApiTokenList: 'view-api-tokens',
    permissionApiTokenRevoke: 'revoke-api-tokens',
    permissionUserSettings: 'user-settings',
  },

  resource: {
    auth: 'Auth',
    user: 'App\\Models\\User\\User',
    role: 'App\\Models\\Permission\\DefaultPermission',
    translation: 'App\\Models\\Translation\\Translation',
    apiToken: 'App\\Models\\ApiToken',
  },

  // BASEURL
  baseUrl: baseUrl.ApiBaseUrl,
  serverBaseUrl: baseUrl.serverBaseUrl,
  debtiaappUrl: baseUrl.debtiaappUrl,
}
